<template>
    <div v-if="showStep" class="step-card-wrapper">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :is-preview="isPreview"
            :is-brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
            :sub-title="subtitle"
        >
            <template slot="details">
                <div v-if="!isComplete" class="network-details">
                    <span class="pdf-ignore" v-for="network in requiredNetworks" :key="network.id">
                        <network-icon :network="network.slug"/>
                    </span>
                </div>
                <div v-else class="content-wrapper network-details">
                    <g-row v-for="network in contact.networks" :key="network.id" type="flex" align="top">
                        <g-column class="pdf-ignore" :span="2">
                            <network-icon :network="network.network.slug" :size="24"/>
                        </g-column>
                        <g-column :span="20">
                            <g-typography class="contact-network-line" tag="h4">
                                {{ network.network.name }}
                            </g-typography>
                            <g-typography tag="p" color="secondary">
                                {{ network.network_username }}
                            </g-typography>
                        </g-column>
                    </g-row>
                </div>
            </template>
        </generic-step-card>
    </div>
</template>

<script>
    import GenericStepCard from '../GenericStepCard';
    import {NAME_NETWORKS} from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';
    import ActivationBriefNetworksMixin from './../../mixins/ActivationBriefNetworksMixin';
    import NetworkIcon from '../../../../../../src/components/interface/elements/NetworkIcon.vue';

    export default {
        name:       'NetworksStepCardView',
        components: {
            GenericStepCard,
            NetworkIcon
        },
        mixins: [
            StepCardViewMixin,
            ActivationBriefNetworksMixin,
        ],
        props: {
            contact: {
                type:     Object,
                required: true,
            },
        },
        computed: {
            stepName() {
                return NAME_NETWORKS;
            },
            subtitle() {
                if (this.isComplete) {
                    return `${this.contact.networks.length} Connected`;
                }
                return undefined;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .step-card-wrapper {
        margin-bottom: $g-spacing-5;
    }
    .network-details {
        margin-top: $g-spacing-5;
    }
    ::v-deep .gi-tiktok {
        width: 1.2em;
        display: inline-block;
        text-align: center;
    }
</style>
